module.exports = __webpack_public_path__ + "be1d540655ec4246d25fa451de69767a.svg";